import React from 'react';
import EmptyFileUploadIcon from '../Icons/EmptyFileUploadIcon';
import Dropzone from 'react-dropzone';

interface ICustomImageUpload {
  onChange: (e: any) => void;
  id: string;
}
export default function CustomImageUpload({
  onChange,
  id,
}: ICustomImageUpload) {
  return (
    <Dropzone
      onDrop={(acceptedFiles) => onChange(acceptedFiles)}
      multiple={false}
      accept={{
        'image/jpeg': [],
        'image/jpg': [],
        'image/png': [],
      }}
    >
      {({ getRootProps, getInputProps }) => (
        <div
          className={
            'px-8 py-6 rounded-8 border border-dashed border-borderColor h-[175px] max-tablet:h-40 flex flex-col items-center justify-center relative cursor-pointer'
          }
        >
          <div {...getRootProps()}>
            <input id={id} {...getInputProps()} />
            <div className={'flex flex-col items-center gap-2 text-center'}>
              <EmptyFileUploadIcon />
              <p className={'text-primary leading-142'}>
                Drop your image here or{' '}
                <span className={'text-blue font-semibold'}>Browse</span>
              </p>
              <p className={'text-12 leading-1 text-[#8992A8]'}>
                Supports: JPG, PNG, JPEG
              </p>
            </div>
          </div>
        </div>
      )}
    </Dropzone>
  );
}
